import type { IUnmatchedGitHubRow, IUnmatchedSlackRow } from '@skystone/shared';

// Source-agnostic row shape used by the three reconciliation dialogs
// (LinkToPersonDialog, CreatePersonDialog, MarkAsBotConfirmDialog).
// Each dialog branches on `source` for API calls and title wording.
export type ReconcileTargetSource = 'slack' | 'github';

export interface ReconcileTarget {
  source: ReconcileTargetSource;
  sourceAccountId: string;
  displayName: string;
  realName?: string;
  email: string | null;
  isBot: boolean;
}

export function toReconcileTargetFromSlack(row: IUnmatchedSlackRow): ReconcileTarget {
  return {
    source: 'slack',
    sourceAccountId: row.slackId,
    displayName: row.displayName || row.realName || row.slackId,
    realName: row.realName,
    email: row.email,
    isBot: row.isBot,
  };
}

export function toReconcileTargetFromGitHub(row: IUnmatchedGitHubRow): ReconcileTarget {
  return {
    source: 'github',
    sourceAccountId: row.login,
    displayName: row.name ?? row.login,
    email: row.email,
    isBot: row.type === 'Bot',
  };
}
